import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { Menu, MenuItem, MenuProps, Typography, styled } from "@mui/material";
import { ReactElement, useState } from "react";

import { palette } from "~frontend/theme";

import TagChip from "./TagChip";

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    marginTop: 0,
    minWidth: 150,
    borderRadius: "16px",
    boxShadow: 0,
    "& .MuiMenu-list": {
      padding: "0",
      backgroundColor: palette.midGreen,
      color: palette.darkGreen,
    },
    "& .MuiMenuItem-root": {
      border: `1px solid white`,
      borderBottom: 0,
      minHeight: "unset",
      justifyContent: "center",

      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:hover": {
        backgroundColor: palette.midGray,
      },
    },
  },
}));

export const DropdownTagChip = ({
  label,
  width = "150px",
  disabled = false,
  menuItems,
}: {
  label: string;
  width?: string | number;
  disabled?: boolean;
  menuItems: {
    key?: string;
    label: string;
    onClick: () => void;
    disabled?: boolean;
  }[];
}): ReactElement => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isOpen = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!disabled) {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <TagChip
        disabled={disabled}
        onClick={handleClick}
        aria-haspopup="true"
        aria-expanded={isOpen ? "true" : undefined}
        sx={{
          margin: "2px",
          border: "2px solid transparent",
          "& .MuiChip-label": {
            display: "inline-flex",
          },
          "& svg": {
            fontSize: "1rem",
          },
        }}
        label={
          <>
            {label}
            {isOpen ? <ArrowDropUp /> : <ArrowDropDown />}
          </>
        }
      />
      <StyledMenu open={isOpen} onClose={handleClose} anchorEl={anchorEl}>
        {menuItems.map(({ key, label, disabled, onClick }) => (
          <MenuItem
            key={key}
            onClick={() => {
              onClick();
              handleClose();
            }}
            disableRipple
            sx={{ width }}
            disabled={disabled}
          >
            <Typography
              variant="body1"
              sx={{
                fontSize: "12px",
                fontWeight: 400,
                lineHeight: "14.4px",
                textAlign: "center",
                textWrap: "wrap",
                width: "100%",
                padding: "0 16px",
              }}
            >
              {label}
            </Typography>
          </MenuItem>
        ))}
      </StyledMenu>
    </>
  );
};
